<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 font-weight-bold mb-3">Telone Receipt</h3>

            <!-- Recharge Success Message -->
            <div v-if="bill.type === 'recharge'" class="alert alert-success mb-4">
                <h5 class="alert-heading">Account Recharged Successfully!</h5>
                <p class="mb-0">Your TelOne account has been successfully recharged.</p>
            </div>

            <div v-if="bill.data">
                <div class="row">
                    <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">PIN : </p>
                    <p class="col-sm-8"><strong>{{ bill.data.PIN }}</strong></p>
                </div>

                <div class="row">
                    <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Card Number : </p>
                    <p class="col-sm-8">{{ bill.data.CardNumber }}</p>
                </div>

                <div class="row">
                    <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Batch Number : </p>
                    <p class="col-sm-8">{{ bill.data.BatchNumber }}</p>
                </div>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Status : </p>
                <p class="col-sm-8">{{ bill.state }}</p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8 font-weight-500">{{ transaction.ref }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>
        </div>
        <div v-if="init || bill.state === 'GENERATING-TOKEN'">
            <h3 class="text-5 text-center mb-5">Generating Token ... </h3>
            <div  class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are generating your TelOne Token</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
        </div>
        <div v-if="bill.state === 'TOKEN-FAILED' ||bill.state ===  'BILL-FAILED'">
            <h3 class="text-5 text-center mb-5">TelOne Purchase Receipt </h3>

            <p class="text-center text-4 mb-5">
                Oops! Looks like the TelOne system is a little unstable right now and your token may take longer to be delivered. You do not have to do anything. You will receive the token as soon as it becomes available. This usually takes at most 1 hour. Contact Magetsi Support if you need any assistance.
            </p>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-6">
                    <button @click.prevent="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh</button>
                </div>
                <div class="col-md-6">
                    <router-link to="/telone" class="btn btn-outline-primary btn-block">Close</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ecocash.vue",
        data()
        {
            return {
                bill : {
                    data : {},
                },
                payment : {},
                transaction : {},
                loading: false,
                init: true,
                countDown : 5,
                ref : this.$route.query.id
            };

        },
        methods : {
            submit()
            {
                if (this.loading)
                {
                    return;
                }

                this.loading = true;
                this.countDown = 0;

                // Check Payment

                window.axios['post'](`${window.location.origin}/telone/token` , {
                    ref : this.ref
                }).then((response) => {

                    this.init = false;
                    if (response.data.success)
                    {
                        this.bill = response.data.body.bill;
                        this.payment = response.data.body.payment;
                        this.transaction = response.data.body.transaction;
                        if (this.bill.state === 'GENERATING-TOKEN')
                        {
                            this.countDown = 30;
                            this.startCountDown();
                        }
                    }

                }).finally(() => {
                    this.loading = false;
                });


            },
            startCountDown()
            {
                if(this.countDown > 0)
                {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.startCountDown();
                    }, 1000);

                } else {

                    if (!this.loading && !this.done)
                    {
                        this.submit();
                    }
                }
            },
        },

        mounted()
        {
            this.submit();
        }
    }
</script>

<style scoped>

</style>
